import OMT_UI_SquareButton, { BUTTONCOLOURS } from '../../../OMT_UI/OMT_UI_SquareButton';
import OMT_UI_DrawUtil from '../../../OMT_UI/Drawing/OMT_UI_DrawUtil';

/**
 * @author Sandra Koo
 */
export class RequestHelp_Leaving extends Phaser.Group {
  /**
   * config = {
   *  inventory: RequestHelp_Inventory
   *  onStay?: function,
   *  onExit?: function
   * }
   * @param {Phaser.Game} inGame
   * @param {Phaser.Group} inParent
   * @param {Object} config
   */
  constructor(inGame, inParent, config) {
    super(inGame, inParent);

    const badOverlay = new Phaser.Graphics(game); // Another overlay that isn't this.showOverlay()
    badOverlay.beginFill(0x000000, 0.7);
    badOverlay.drawRect(0, 0, game.width * 2, game.height * 2);
    badOverlay.endFill();
    badOverlay.inputEnabled = true;
    badOverlay.x = -badOverlay.width / 2;
    badOverlay.y = -badOverlay.height / 2;

    const bg = G.makeImage(0, 0, 'popup_background_2', 0.5, null);

    const warningText = new G.Text(0, -bg.height * 0.37, OMT.language.getText("Don't lose the help from your friends!"), {
      style: 'font-white',
      fontSize: 70,
      align: 'center',
      lineSpacing: -10,
    }, 0.5, 420, 120, true, 'center');

    const onClick = () => {
      if (config.onStay) {
        config.onStay();
      }

      this.destroy();
    };
    const keepPlayingBtn = new OMT_UI_SquareButton(0, 0, {
      button: {
        tint: BUTTONCOLOURS.green,
        dimensions: {
          width: 445,
          height: 100,
        },
      },
      text: {
        string: OMT.language.getText('Keep Playing'),
        textStyle: { style: 'font-white', fontSize: 48 },
      },
      options: {
        clickFunction: {
          onClick: onClick.bind(this),
        },
      },
    });

    const onQuit = () => {
      if (config.onExit) {
        config.onExit();
      }
      this.destroy();
    };
    const boosterNames = [];
    const quitButton = new OMT_UI_SquareButton(0, 0, {
      button: {
        tint: BUTTONCOLOURS.red,
        dimensions: {
          width: 166,
          height: 86,
        },
        extraDetail: false,
      },
      text: {
        string: OMT.language.getText('Exit Level'),
        textStyle: { style: 'font-white', fontSize: 48 },
      },
      options: {
        clickFunction: {
          onClick: onQuit.bind(this),
        },
      },
    });
    quitButton.y = bg.y + (bg.height / 2) - quitButton.height - 5;
    keepPlayingBtn.y = quitButton.y - keepPlayingBtn.height + 2;

    const boosters = new Phaser.Group(G.game, null); // A group for the boosters
    const boosterPadding = 5;
    const boosterDimensions = new Phaser.Rectangle(0, 0, 100, 100);
    // estimated width of #boosters (max 3) per line
    let estimatedWidth = (Math.min(config.inventory.items.length, 3) * boosterDimensions.width) + ((Math.min(config.inventory.items.length, 3) - 1) * boosterPadding);
    let originX = (boosterDimensions.width - estimatedWidth) / 2; // Calculated the beginning padding
    let nextX = originX;
    let nextY = 0;
    for (let i = 0; i < config.inventory.items.length; i++) {
      if (i !== 0 && (i % 3 === 0)) { // New row time?
        // Recalculates whats left
        estimatedWidth = (Math.min(config.inventory.items.length - i, 3) * boosterDimensions.width) + ((Math.min(config.inventory.items.length - i, 3) - 1) * boosterPadding);
        originX = (boosterDimensions.width - estimatedWidth) / 2; // New beginning padding
        nextY += boosterDimensions.height + 10;
        nextX = originX;
      }

      const prizeData = config.inventory.items[i];
      const boosterImg = new Phaser.Group(G.game, null);
      const booster = G.makeImage(0, 0, OMT_UI_DrawUtil.getGiftString(prizeData.prize), 0.5, null);
      const cross = G.makeImage(0, 0, 'task_fail', 0.5, null); // X
      boosterImg.width = boosterDimensions.width;
      boosterImg.height = boosterDimensions.height;
      cross.width = boosterDimensions.width * 0.3;
      cross.height = boosterDimensions.height * 0.3;
      cross.x = cross.width / 2 - boosterDimensions.width / 2;
      cross.y = -cross.height / 2 + boosterDimensions.height / 2;

      boosterImg.addChild(booster);
      boosterImg.addChild(cross);
      boosterImg.x = nextX;
      boosterImg.y = nextY;

      boosters.addChild(boosterImg);
      boosterNames.push(prizeData.prize);

      nextX += boosterDimensions.width + boosterPadding;
    }
    boosters.y = -boosters.height / 2;

    this.addChild(badOverlay);
    this.addChild(bg);
    this.addChild(warningText);
    this.addChild(boosters);
    this.addChild(keepPlayingBtn);
    this.addChild(quitButton);
  }
}
